// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"0a1d9587","689":"6cbc4fcb","787":"19dc588a"}[chunkId] + ".chunk.js";
};